module.exports = __webpack_public_path__ + "static/media/airpods.294264f2.webp";